module.exports = __webpack_public_path__ + "img/Flag_of_Guatemala.53097ea8.svg";